<template>
  <div class="bg-white !shadow rounded-md py-2 px-3 text-lg">
    <div class="text-xl font-bold mb-3">Shuttle</div>
    <div class="space-y-3 text-lg mb-3"
      v-if="existsTripData">
      <HighlightChange class="flex flex-row items-center gap-3"
        changeType="">
        <div v-if="showRouteDetailModal">
          <RouteDetailModal
            :routeId="tripData.route_id"
            :title="`${tripData.vehicle_code} - Shuttle`"
            :date="selectedDate"
            direction="Shuttle"
          />
        </div>
        <div class="font-bold">
          Vehicle Number
        </div>
        <div v-if="tripData.vehicle_code">
          <span class="text-gray-600">{{ tripData.vehicle_code }}</span>
        </div>
        <div v-else>
          <span class="text-gray-300">---</span>
        </div>
      </HighlightChange>
      <HighlightChange class="flex flex-row items-center gap-3"
        changeType="">
        <div class="font-bold">
          Pickup Time
        </div>
        <div v-if="tripData.pickup_time">
          <span>{{ pickupTimeDisplay }}</span>
        </div>
        <div v-else>
          <span class="text-gray-300">---</span>
        </div>
      </HighlightChange>
      <HighlightChange class="flex flex-row gap-3"
        changeType="">
        <div class="font-bold">
          Dropoff Time
        </div>
        <div v-if="tripData.dropoff_time">
          <span>{{ dropoffTimeDisplay }}</span>
        </div>
        <div v-else>
          <span class="text-gray-300">---</span>
        </div>
      </HighlightChange>
      <HighlightChange
        changeType="">
        <BuildingDisplay
          type="pickup"
          :buildingData="tripData.pickup_building"
        />
      </HighlightChange>
      <HighlightChange
        changeType="">
        <BuildingDisplay
          type="dropoff"
          :buildingData="tripData.dropoff_building"
        />
      </HighlightChange>
    </div>
    <div class="space-y-3 text-lg mb-3"
      v-if="!existsTripData">
      None
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import time from '../../../../services/utils/time.js'

import BuildingDisplay from '../BuildingDisplay.vue'

import HighlightChange from '../../utilities/HighlightChange.vue'

import RouteDetailModal from '../../../modals/RouteDetailModal.vue'

export default {
  components: {
    BuildingDisplay,
    HighlightChange,
    RouteDetailModal,
  },
  props: {
    showRouteDetailModal: {
      type: Boolean,
      default: false,
    },
    tripData: Object,
    tripDataDiff: Object,
    overrideDropoffBuilding: {
      type: Object,
      default: undefined,
    },
    selectedDate: String,
  },
  computed: {
    existsTripData() {
      return !(this.tripData == undefined || isEmpty(this.tripData))
    },
    pickupTimeDisplay() {
      return time.formatAMPM(this.tripData?.pickup_time)
    },
    dropoffTimeDisplay() {
      return time.formatAMPM(this.tripData?.dropoff_time)
    },
  },
}
</script>
